import dateComparator from "./DateComparator";

import filterParams from "./DateFilter";

// header-cell_Lunettes
let cellClassRules = {
  "header-cell_Lunettes": 'data.TypeCO === "CO (lunettes portée)"',
  "header-cell_Lunettes_finale": 'data.TypeCO === "Correction finale"',
  // "acte_realise": 'data.fk_id_examen === 5',
  // "acte_propose": 'data.fk_id_examen === 4'
};
let isHeaderRow = (params) => {
  if (params.data.TypeCO === "CO (lunettes portée)") {
    return true;
  } else if (params.data.TypeCO === "Correction finale") {
    return true;
  } else {
    return false;
  }
  // return params.data.TypeCO === "CO (lunettes portée)";
};

export const columnDefs = [
  {
    headerName: "MontureNewAVOptions",
    field: "MontureNewAVOptions",
    editable: false,
    hide: true,
  },
  {
    headerName: "date_consultation_lunette",
    field: "date_consultation_lunette",
    editable: false,
    hide: true,
  },
  {
    headerName: "TypeCO",
    field: "TypeCO",
    editable: false,
    hide: true,
  },
  {
    headerName: "fk_id_examen",
    field: "fk_id_examen",
    editable: false,
    hide: true,
  },
  {
    headerName: "Antireflettxt",
    field: "Antireflettxt",
    editable: false,
    hide: true,
  },
  {
    headerName: "Photocromictxt",
    field: "Photocromictxt",
    editable: false,
    hide: true,
  },

  {
    headerName: "FiltreBluetxt",
    field: "FiltreBluetxt",
    editable: false,
    hide: true,
  },

  {
    headerName: "SolaireAntiUVtxt",
    field: "SolaireAntiUVtxt",
    editable: false,
    hide: true,
  },
  //////////////////////////
  {
    headerName: "Photocromic",
    field: "Photocromic",
    editable: false,
    hide: true,
  },
  {
    headerName: "SolaireAntiUV",
    field: "SolaireAntiUV",
    editable: false,
    hide: true,
  },
  {
    headerName: "Antireflet",
    field: "Antireflet",
    editable: false,
    hide: true,
  },
  {
    headerName: "FiltreBlue",
    field: "FiltreBlue",
    editable: false,
    hide: true,
  },
  {
    headerName: "nomPrenomCivilite",
    field: "nomPrenomCivilite",
    editable: false,
    hide: true,
  },
  {
    headerName: "id_lunettes",
    field: "id_lunettes",
    editable: false,
    hide: true,
  },
  {
    headerName: "fk_id_patientLunette",
    field: "fk_id_patientLunette",
    editable: false,
    hide: true,
  },
  {
    editable: false,
    // checkboxSelection: true,
    headerName: "DATE",
    // field: 'created_at',
    valueGetter: ({ data }) => {
      if (data.TypeCO === "CO (lunettes portée)") {
        return `${data.created_at} - (lunettes portée)`;
      } else if (data.TypeCO === "Correction finale") {
        return `${data.created_at} - (Correction finale)`;
      } else {
        return data.created_at;
      }
    },
    cellClassRules: cellClassRules,
    checkboxSelection: (params) => {
      if (isHeaderRow(params)) {
        return true;
      } else {
        return true;
      }
    },
    colSpan: (params) => {
      if (isHeaderRow(params)) {
        return 12;
      } else {
        return 1;
      }
    },
    filter: "agDateColumnFilter",
    filterParams: filterParams,
    comparator: dateComparator,
  },
  {
    headerName: "AV OD",
    field: "avOD",
    filterParams: {
      defaultOption: "startsWith",
    },
  },
  {
    headerName: "SPH OD",
    field: "sphOD",
    filterParams: {
      defaultOption: "startsWith",
    },
  },
  {
    headerName: "CYL OD",
    field: "cylOD",
    filterParams: {
      defaultOption: "startsWith",
    },
  },
  {
    headerName: "AXE OD",
    field: "axeOD",
    filterParams: {
      defaultOption: "startsWith",
    },
  },
  {
    headerName: "ADD OD",
    field: "addOD",
    filterParams: {
      defaultOption: "startsWith",
    },
  },
  {
    headerName: "AV OG",
    field: "avOG",
    filterParams: {
      defaultOption: "startsWith",
    },
  },
  {
    headerName: "SPH OG",
    field: "sphOG",
    filterParams: {
      defaultOption: "startsWith",
    },
  },
  {
    headerName: "CYL OG",
    field: "cylOG",
    filterParams: {
      defaultOption: "startsWith",
    },
  },
  {
    headerName: "AXE OG",
    field: "axeOG",
    filterParams: {
      defaultOption: "startsWith",
    },
  },
  {
    headerName: "ADD OG",
    field: "addOG",
    filterParams: {
      defaultOption: "startsWith",
    },
  },
  {
    headerName: "observation",
    field: "observation",
    filterParams: {
      defaultOption: "startsWith",
    },
    editable: false,
    // hide: true,
  },

  // 1ere sous catégorie
];

export const defaultColDef = {
  suppressMovable: true,
  sortable: true,
  editable: true,
  flex: 1,
  // filter stuff
  filter: true,
  // floatingFilter: true,
  // suppressMenu: true,
  // end of filter stuff
  minWidth: 100,
  // resizable: true,
  // tooltipComponent: 'customTooltip',
  filterParams: {
    newRowsAction: "keep",
    // buttons: ['apply', 'clear'],
  },
  resizable: true,
  cellClass: "cell-wrap-text",
  // autoHeight: true
};
